import DocumentSchema from '../../../../../../json_schemas/base/document.json'
import { CustomerBase } from '../json-schemas/base/customer'
import { DocumentBase } from '../json-schemas/base/document'
import { EmployeeBase } from '../json-schemas/base/employee'
import { MarketplaceBase } from '../json-schemas/base/marketplace'
import { SupplierBase } from '../json-schemas/base/supplier'
import { ThirdPartyPayerBase } from '../json-schemas/base/third_party_payer'
import { UserBase } from '../json-schemas/base/user'
import { DocumentListResponse } from '../json-schemas/serializers/document-list-response'
import { httpDelete, httpGet, httpGetRoute, httpPatch, httpPost, httpRecoverable } from '../utils/http.service'
import { I18nService } from '../utils/i18n.service'
import i18nScopedData from './documents.service.yml'

const i18nScoped = new I18nService(i18nScopedData)
export const documentFileTypes = DocumentSchema.properties.file_type.enum as DocumentBase['file_type'][]

export interface RansackQueryVariant {
  // Backoffice
  backoffice_ogustine?: boolean
  backoffice_terms?: boolean
  backoffice_marketplace?: { marketplace_id: MarketplaceBase['id'] }
  backoffice_customer?: { customer_id: CustomerBase['id'] }
  backoffice_employee?: { employee_id: EmployeeBase['id'] }
  backoffice_third_party_payer?: { third_party_payer_id: ThirdPartyPayerBase['id'] }

  // Market
  market_ogustine?: boolean
  market_terms?: boolean
  market_supplier?: { supplier_id: SupplierBase['id'] }
  market_customer?: { customer_id: CustomerBase['id'] }

  // Prescription
  prescription_ogustine?: boolean
  prescription_customer?: { customer_id: CustomerBase['id'] }
}


export interface RansackQuery {
  'q[id_not_in][]'?: number[]
  'q[file_type_eq]'?: DocumentBase['file_type']
  'q[waiting_signature_for_user_id_eq]'?: UserBase['id']
  variant: RansackQueryVariant | null /** mandatory for backoffice / market / prescription */
}

export const documentCustomerFileTypes: DocumentBase['file_type'][] = ['invoice', 'receipt', 'mandate', 'certificate', 'contract', 'quotation', 'end_of_contract', 'other_type']
export const documentEmployeeFileTypes: DocumentBase['file_type'][] = ['internal_document', 'application', 'identity', 'mandate', 'contract', 'invoice', 'certificate', 'payslip', 'end_of_contract', 'other_type']
export const documentSupplierFileTypes: DocumentBase['file_type'][] = ['internal_document', 'contract', 'invoice', 'mandate', 'other_type']
export const documentMarketplaceFileTypes: DocumentBase['file_type'][] = ['identity', 'contract', 'invoice', 'mandate', 'other_type']
export const documentThirdPartyPayerFileTypes: DocumentBase['file_type'][] = ['invoice', 'mandate', 'contract', 'other_type']

export function documentList (query: RansackQuery): Promise<DocumentListResponse> {
  return httpGet(`/${httpGetRoute()}/documents`, query)
}

export function documentCreate (body: any) {
  return httpPost(`/${httpGetRoute()}/documents`, { document: body })
}

export function documentPay (id: number, body: any) {
  return httpPatch(`/${httpGetRoute()}/documents/${id}/add_payment`, { document: body })
}

export function documentDelete (id: number) {
  return httpDelete(`/${httpGetRoute()}/documents/${id}`)
}

export function documentTriggerPayment (id: number) {
  return httpRecoverable('PATCH', `/${httpGetRoute()}/documents/${id}/trigger_payment`, {}, null)
}

export function documentMarkSeen (id: number) {
  return httpPatch(`/${httpGetRoute()}/documents/${id}/mark_seen`, {})
}

export function documentI18nFileType (fileType: DocumentBase['file_type'] | 'credit_invoice'): string {
  return i18nScoped.t('file_type.' + fileType)
}

export function documentFileTypeCanBeSignable (documentType: DocumentBase['file_type']) {
  return (['contract', 'mandate', 'quotation', 'end_of_contract'] as DocumentBase['file_type'][]).includes(documentType)
}
